module.exports = __webpack_public_path__ + "fa-solid-900.ttf?b9625119ce4300f0ef890a8f3234c773";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-solid-900.ttf
// module id = 1458
// module chunks = 0